var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Crop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-157.000000, -7.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crop",
    transform: "translate(157.941125, 7.485365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2777778,0.707106781 L9.97222222,3.04289322 L9.97222222,10.25 L12.1388889,10.25 L2.66666667,10.3333333 L2.66666667,0.861111111 L2.75,3.02777778 L9.95710678,3.02777778 L12.2777778,0.707106781 Z M9.88888889,3.12622655 L2.76511544,10.25 L9.88888889,10.25 L9.88888889,3.12622655 Z M9.87377345,3.11111111 L2.75,3.11111111 L2.75,10.2348846 L9.87377345,3.11111111 Z",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/Crop.05478a84df987ff64035b8a9eee93fb4.svg";
export { ForwardRef as ReactComponent };